import {
  Exam,
  FireStoreTimestamp,
  Grade,
  Question,
  Section,
} from "../../../../model/model";

export const examTransformer = {
  fromFirestore: (
    exam: Exam,
    questions: Question[],
    sections: Section[]
  ): Exam => {
    const points = {
      autoPoints: exam.autoPoints || 0,
      totalPoints: exam.totalPoints || 0,
      humanPoints: exam.humanPoints || 0,
      noAnswerCount: exam.noAnswerCount || 0,
    };

    // If the exam has grades, use them
    // Otherwise, calculate the grades based on the questions and results
    const grades: Grade[] = !!exam.grades?.length
      ? exam.grades
      : questions
          .filter((question) => !question.depricated)
          .filter((question) => question.name in exam.results)
          .map((question) => {
            const result = exam.results[question.name];
            const section = sections.find((s) => s.id === question.section);
            const valid =
              !!result &&
              question.answer.includes(result.toLocaleLowerCase("is"));
            const autoPoints = valid ? question.value : 0;

            // console.log(question.name, { result, valid, autoPoints });

            if (valid) {
              points.autoPoints += autoPoints;
            } else if (!result) {
              points.noAnswerCount++;
            }

            const grade: Grade = {
              id: question.name,
              human: question.human,
              section: section ? section.name : "unknown",
              answer: result,
              correct: question.answer,
              valid,
              value: question.value,
              autoPoints,
              humanPoints: 0,
            };
            return grade;
          });

    return {
      ...exam,
      ...points,
      grades,
    };
  },
  toDate: (timestamp: FireStoreTimestamp): Date | undefined => {
    if (timestamp) {
      return new Date(timestamp._seconds * 1000);
    }
    return undefined;
  },
};
